<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix text-center">
            <h1 class="display-3 mt-4">404</h1>
            <p class="text-muted">The page you requested was not found</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  import {EventBus} from '../../utils/event-bus';

  export default {
        name: 'Page404',
        created() {
          EventBus.$emit('wk-lazy-comp-ready', true);
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/errors/Page404.vue